import { render, staticRenderFns } from "./GiftForm.vue?vue&type=template&id=591ee685&"
import script from "./GiftForm.vue?vue&type=script&lang=js&"
export * from "./GiftForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports